<template>
  <div class="pt-3 pl-4">
    <h1 class="mb-2">{{ data.title }}</h1>

    <div v-if="loading">
      <div class="loader1">
        <v-skeleton-loader type="text" />
      </div>
      <div class="loader2">
        <v-skeleton-loader type="text" />
      </div>
    </div>

    <div v-else>
      <div class="d-flex align-center mb-2">
        <mf-icon icon="group" color="rgba(0, 0, 0, 0.6)" size="24" />
        <h2 class="mb-0 ml-1">{{ data.clients | localeString }}</h2>
      </div>
      <div class="d-flex align-center">
        <span>R$</span>
        <h2 class="mb-0 ml-1">{{ data.value | localeString(2) }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RfvGraphItem',
  components: {},
  props: {
    period: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['analyticsConfiguration']),
  },
}
</script>

<style lang="scss" scoped>
.loader1 {
  width: 96px;
}

.loader2 {
  width: 147px;
}

h1 {
  color: $preto;
  font-size: 20px;
  line-height: 120%;
  font-weight: 700;
}

h2 {
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
}

span {
  color: rgba(0, 0, 0, 0.6);
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  display: inline-block;
  width: 24px;
}

::v-deep .mf-icon {
  color: rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-skeleton-loader__text {
  border-radius: 4px !important;
}
</style>
